import {
    get_notifiche,
    get_conteggio_non_lette,
    segna_notifica_letta,
    segna_tutte_lette,
} from "@/api/api.notifiche.js";

const notifiche = {
    namespaced: true,

    state: {
        lista: [],
        nonLette: 0,
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
        SET_NON_LETTE: (state, n) => {
            state.nonLette = n;
        },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_notifiche().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaConteggio({ commit }) {
            return new Promise((resolve, reject) => {
                get_conteggio_non_lette().then(resp => {
                    commit("SET_NON_LETTE", resp.data.conteggio);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        segnaLetta({ commit, state }, id) {
            return new Promise((resolve, reject) => {
                segna_notifica_letta(id).then(resp => {
                    // Aggiorna la lista locale senza un nuovo fetch completo, e
                    // decrementa il badge se la notifica non era già letta.
                    const n = state.lista.find(x => x.id === id);
                    if (n && !n.letta) {
                        n.letta = true;
                        commit("SET_NON_LETTE", Math.max(0, state.nonLette - 1));
                    }
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        segnaTutteLette({ commit, dispatch }) {
            return new Promise((resolve, reject) => {
                segna_tutte_lette().then(resp => {
                    commit("SET_NON_LETTE", 0);
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        nonLette: state => state.nonLette,
    },
};

export default notifiche;
